import { useEffect, useState } from "react";
import { useLanguage } from "../../contexts/LanguageContext";

export const LiveClock = ({ compact = false }) => {
  const { language, t } = useLanguage();

  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  if (compact) {
    return (
      <div className="flex items-center gap-2" data-testid="live-clock">
        <span className="text-sm font-medium text-[var(--app-text)] tabular-nums font-mono">
          {time.toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit", hour12: false })}
        </span>
        <span className="text-xs text-[var(--app-text-muted)]">
          {time.toLocaleDateString("es-MX", { weekday: "short", day: "2-digit", month: "short" })}
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3" data-testid="live-clock">
      <div className="text-3xl font-light text-[var(--app-text)] tabular-nums tracking-wide font-mono">
        {time.toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false })}
      </div>
      <div className="text-xs text-[var(--app-text-muted)] leading-tight">
        <div>{time.toLocaleDateString("es-MX", { weekday: "short" }).toUpperCase()}</div>
        <div>{time.toLocaleDateString("es-MX", { day: "2-digit", month: "short" })}</div>
      </div>
    </div>
  );
};
